import React from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import {
  BuildingsIcon,
  ChartLineIcon,
  SignOutIcon,
  UserCircleIcon,
  ShieldStarIcon,
  ArrowSquareOutIcon,
} from "@phosphor-icons/react";

export default function SuperAdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const items = [
    { to: "/super-admin", label: "Overview", icon: ChartLineIcon, end: true, tid: "sa-nav-overview" },
    { to: "/super-admin/companies", label: "Companies", icon: BuildingsIcon, tid: "sa-nav-companies" },
  ];

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <div className="flex min-h-screen bg-white text-slate-700">
      <aside className="w-64 bg-white border-r border-slate-300 flex flex-col fixed h-screen z-30" data-testid="sa-sidebar">
        <div className="px-6 py-6 border-b border-slate-300">
          <Link to="/super-admin" className="flex items-center gap-3">
            <img src="/logo.png" alt="Rep Fleet" className="w-11 h-11 rounded-sm bg-white object-contain border border-slate-200" />
            <div>
              <div className="font-display font-black text-lg tracking-tighter text-slate-900 leading-none">REP FLEET</div>
              <div className="font-mono text-[10px] text-blue-600 uppercase tracking-widest mt-1">Super Admin</div>
            </div>
          </Link>
        </div>

        <nav className="flex-1 py-4">
          <div className="px-6 mb-2 text-[10px] uppercase tracking-[0.2em] font-mono text-slate-500 font-bold">Platform</div>
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                data-testid={it.tid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-6 py-2.5 text-sm border-l-2 transition-colors ${
                    isActive
                      ? "bg-blue-600/10 border-blue-500 text-blue-700 font-semibold"
                      : "border-transparent text-slate-400 hover:bg-slate-100 hover:text-slate-700"
                  }`
                }
              >
                <Icon size={16} weight="bold" />
                <span>{it.label}</span>
              </NavLink>
            );
          })}

          <div className="px-6 mt-6 mb-2 text-[10px] uppercase tracking-[0.2em] font-mono text-slate-500 font-bold">Quick Links</div>
          <a
            href="/"
            className="flex items-center gap-3 px-6 py-2.5 text-sm border-l-2 border-transparent text-slate-400 hover:bg-slate-100 hover:text-slate-700"
            data-testid="sa-nav-marketing"
          >
            <ArrowSquareOutIcon size={16} weight="bold" />
            <span>Marketing Site</span>
          </a>
        </nav>

        <div className="border-t border-slate-300 p-4">
          <div className="flex items-center gap-3 mb-3" data-testid="sa-user-info">
            <div className="w-9 h-9 rounded-sm bg-blue-600/10 border border-blue-500/40 flex items-center justify-center">
              <UserCircleIcon size={22} className="text-blue-600" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-slate-900 truncate">{user?.name}</div>
              <div className="font-mono text-[10px] uppercase tracking-wider text-blue-600">super admin</div>
            </div>
          </div>
          <button
            onClick={handleLogout}
            data-testid="sa-logout"
            className="w-full flex items-center justify-center gap-2 text-sm bg-slate-200 hover:bg-slate-700 text-slate-700 py-2 rounded-sm transition-colors font-medium"
          >
            <SignOutIcon size={16} weight="bold" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-h-screen ml-64">
        <Outlet />
      </main>
    </div>
  );
}
